export default function MobileCallButton() {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 w-full z-50">
      <a
        href="tel:5558007283"
        className="flex items-center justify-center gap-3 bg-safety-500 text-asphalt-900 font-body font-700 text-base uppercase tracking-wider py-4 w-full cursor-pointer whitespace-nowrap"
      >
        <i className="ri-phone-fill text-xl" />
        TAP TO CALL (555) 800-7283
      </a>
    </div>
  );
}
